module.exports = __webpack_public_path__ + "img/2025-0512-01-01.d5360ddf.png";